import { useState } from "react";
import { Trash2 } from "lucide-react";
import { ConfirmationModal } from "../../components/ConfirmationModal";
import { formApi } from "./api";
import type { FeedbackForm } from "./contract";

export function DeleteDraftButton({
  form,
  onDeleted,
  disabled = false,
}: {
  form: FeedbackForm;
  onDeleted: () => void;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false),
    [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  if (form.status !== "draft" || form.published_at || form.response_count)
    return null;
  async function remove() {
    setBusy(true);
    setError("");
    try {
      await formApi.remove(form.id, form.revision);
      try {
        sessionStorage.removeItem(`argus.form.draft.${form.id}`);
      } catch {
        /* optional storage */
      }
      setOpen(false);
      onDeleted();
    } catch (e) {
      setError(e instanceof Error ? e.message : "Could not delete this draft.");
      setOpen(false);
    } finally {
      setBusy(false);
    }
  }
  return (
    <div>
      <button
        type="button"
        className="glass-button-secondary text-red-400"
        disabled={disabled || busy}
        onClick={() => setOpen(true)}
      >
        <Trash2 className="w-3.5 h-3.5" />
        Delete draft
      </button>
      {error && (
        <p role="alert" className="text-xs text-red-400 mt-2">
          {error}
        </p>
      )}
      <ConfirmationModal
        isOpen={open}
        title="Delete this draft?"
        message={`“${form.title}” will be permanently deleted. This cannot be undone.`}
        confirmText="Delete draft"
        cancelText="Keep draft"
        isLoading={busy}
        onClose={() => {
          if (!busy) setOpen(false);
        }}
        onConfirm={() => void remove()}
      />
    </div>
  );
}
